module.exports = __webpack_public_path__ + "fonts/DM_Sans-500-latin-ext10.0d3827b.woff2";